<template>
    <el-dialog :title="title" custom-class="meetDialog" :visible.sync="showDialog" append-to-body width="455px" @close="closeAddDialog">
        <slot name="body" />
        <div class="content">
            <div v-if="!attendLeader" class="flex">
                <div v-text-lbl="'conferenceTheme'" class="typeface" style="font-size: 14; width: 90px">会议主题：</div>
                <el-input v-model="meetSubjedt" :placeholder="$tx('hygl.portlet.conference', '请输入会议主题')" />
            </div>
            <div v-if="!attendLeader" class="flex">
                <div v-text-lbl="'meetingTime'" class="typeface" style="font-size: 14; width: 70px">会议时段：</div>
                <el-time-select
                    v-model="startTime"
                    style="border: 0"
                    :picker-options="{
                        start: minTime,
                        step: '00:15',
                        end: endTime,
                        minTime: minTime,
                        maxTime: endTime
                    }"
                    :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')"
                />
                {{ $tx('hygl.common.to', '至') }}
                <el-time-select
                    v-model="endTime"
                    style="border: 0"
                    :picker-options="{
                        start: startTime,
                        step: '00:15',
                        end: maxTime,
                        minTime: startTime
                    }"
                    :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')"
                />
                <div v-text-lbl="'totalTime'" class="typeface" style="background: #fafafa; border: 1px solid #ebebeb; border-radius: 8px; display: flex; width: 100px; height: 37px; align-items: center; justify-content: center" :totalTime="allTime·">共{{ allTime }}小时</div>
            </div>
            <div :class="attendLeader == 0 ? 'flex' : 'flex1'">
                <div v-text-lbl="'participants'" :class="attendLeader == 0 ? 'typeface' : 'typeface1'" style="font-size: 14; width: 90px">参会人员：</div>
                <div style="width: 100%">
                    <div>
                        <el-input v-model="attendLeader" :placeholder="$tx('hygl.portlet.participantsPlaceholder', '请输入参会人员')" type="text" style="border: none; box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.04); border-radius: 12px" suffix-icon="el-icon-search" @input="interaction()" />
                        <div v-if="attendLeader" style="height: 190px">
                            <div class="result scroll">
                                <div
                                    v-for="item in searchData && searchData.length > 0
                                        ? searchData.filter((el, idx) => {
                                              return idx < 3
                                          })
                                        : []"
                                    :key="item"
                                >
                                    <div class="user">
                                        <div class="left">
                                            <div class="name">{{ item.name }}</div>
                                            <div class="detial">
                                                <span>{{ item.orgFullName.replace('-', '/') }}</span>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <div class="" @click="getSelect(item)">
                                                <img class="po-r" style="width: 16px; top: 10px" :src="'../imgs/meet_add.png'" alt="" srcset="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex" style="justify-content: flex-start; flex-wrap: wrap">
                <div v-for="(item, index) in attendeeser" :key="index" style="background: #fafafa; border: 1px solid #ebebeb; border-radius: 8px; display: flex; width: 110px; margin: 5px; height: 32px; align-items: center; justify-content: space-between; padding: 0 10px">
                    <div>
                        <span>{{ item.name }}</span>
                    </div>
                    <div><i class="el-icon-close" @click="deleteAttendees(index)" /></div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="status == 0" v-text-lbl="'bookNow'" type="primary" class="typeface" @click="submit()">立刻预定</el-button>
            <button v-else v-text-lbl="'hasBook'" class="typeface button1" disabled style="backgroud-color: rgba(0, 0, 0, 0.2)">会议室已被预订</button>
        </span>
    </el-dialog>
</template>

<script>
const moment = require('moment')
export default {
    components: {},
    props: {
        title: { type: String, default: '' }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'portlet',
            loginUser: this.$store.getters.loginUser,
            meetSubjedt: '',
            startTime: '',
            endTime: '',
            minTime: '',
            maxTime: '',
            time1: '',
            time2: '',
            time3: '',
            time4: '',
            allTime: '0',
            attendLeader: '',
            meetingRoom: '',
            employeeno: '',
            attendeeser: [],
            showDialog: false,
            status: 0, // 0为空闲  1为已约定
            searchData: {
                contactsData: null,
                weaverData: null,
                portalData: null
            },
            activeDate: null,
            vo: {},
            cityName: ''
        }
    },
    computed: {},
    watch: {
        startTime(val) {
            if (val) {
                this.checkTime()
            }
        },
        endTime(val) {
            if (val) {
                this.checkTime()
            }
        }
    },
    created() {
        this.$bus.on('openMeetDialog', this.openMeetDialog)
    },
    beforeDestroy() {
        this.$bus.off('openMeetDialog', this.openMeetDialog)
    },
    mounted() {},
    methods: {
        openMeetDialog(minTime, maxTime, selectStartTime, selectEndTime, meetingRoom, cityName, day) {
            console.log(minTime, maxTime, selectStartTime, selectEndTime, meetingRoom)
            console.log('this.loginUser.', this.loginUser)
            this.cityName = cityName
            this.meetingRoom = meetingRoom
            this.minTime = minTime
            this.maxTime = maxTime
            this.startTime = selectStartTime
            this.endTime = selectEndTime
            this.status = 0
            this.activeDate = day
            this.showDialog = true
            this.attendeeser = [{ name: this.loginUser.personName, isCreate: true, employeeno: this.loginUser.employeeNo }]
            this.employeeno = this.loginUser.employeeNo
            this.addNewMeeting()
        },
        checkTime() {
            if (this.startTime && this.endTime) {
                const pattern = /\//g
                const options = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }
                var date = new Date()
                // if (this.activeDate) {
                //     date = new Date(this.activeDate)
                // }
                var start = date.toLocaleDateString('zh-CN', options) + ' ' + this.startTime
                var end = date.toLocaleDateString('zh-CN', options) + ' ' + this.endTime
                this.time1 = new Date(start).getTime() / 1000
                this.time2 = new Date(end).getTime() / 1000
                var all = this.time2 - this.time1
                this.allTime = Math.fround(all / (60 * 30) / 2)
                this.time3 = start.replace(pattern, '-')
                this.time4 = end.replace(pattern, '-')
                // console.log(this.time3, 123)
            }
        },
        // 搜索查人
        interaction() {
            const params = {
                name: this.attendLeader,
                urlsearch: 'orgCode:jkznkj'
            }
            if (this.attendLeader.length >= 2) {
                this.$http({
                    method: 'POST',
                    params: params,
                    // url: '/user/interactiveInfo/queryLinkManLikeName'
                    url: 'base/organMgr/queryLinkManByPager'
                }).then((res) => {
                    if (res.code === 'success') {
                        console.log(res, 171)
                        this.searchData = res.body.pageInfo.list || []
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        addNewMeeting() {
            this.$http({
                method: 'POST',
                url: 'hygl/meeting/addNew'
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo = res.body.vo
                }
            })
        },
        getSelect(row) {
            this.attendLeader = ''
            this.attendeeser.push(row)
            var newArr = []
            const obj = {}
            let selected = ''
            for (let i = 0; i < this.attendeeser.length; i++) {
                if (!obj[this.attendeeser[i].employeeno]) {
                    newArr.push(this.attendeeser[i])
                    obj[this.attendeeser[i].employeeno] = true
                }
            }
            this.attendeeser = newArr
            this.attendeeser.forEach((item) => {
                if (selected !== '') selected += ','
                selected += item.employeeno
            })
            this.employeeno = selected
            console.log(this.employeeno)
        },
        deleteAttendees(index) {
            this.attendeeser.splice(index, 1)
            let selected = ''
            this.attendeeser.forEach((item) => {
                if (selected !== '') selected += ','
                selected += item.employeeno
            })
            this.employeeno = selected
        },
        closeAddDialog() {
            this.showDialog = false
            this.meetSubjedt = ''
            this.attendLeader = ''
            this.attendeeser = []
            this.$parent.cancelClick()
        },
        submit() {
            if (this.meetSubjedt == '') {
                return this.$alert(this.$tx('hygl.message.meetingThemeNeed', '会议主题是必须的！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
            } else if (this.startTime == '' || this.endTime == '') {
                return this.$alert(this.$tx('hygl.message.meetingTimeNeed', '会议时段是必须的！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
            } else if (this.time1 < new Date().getTime() / 1000) {
                return this.$alert(this.$tx('hygl.message.sSmallCur', '开始时间不能小于当前时间'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
            } else if (this.employeeno == '') {
                return this.$alert(this.$tx('hygl.portlet.chryTip', '参会人员是必须的！'), this.$tx('common.operationTip', '操作提示'), {
                    confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                    type: 'warning'
                })
            }
            this.vo.meetRoomId = this.meetingRoom.id
            this.vo.meetSubjedt = this.meetSubjedt
            this.vo.beginTime = this.time3
            this.vo.endTime = this.time4
            this.vo.approve = 0
            this.vo.applayName = this.loginUser.personName
            this.vo.applyUserid = this.loginUser.personId
            this.vo.departmentUser = this.loginUser.personId
            this.vo.meetName = this.meetingRoom.name
            this.vo.numPeople = this.meetingRoom.numPeople
            this.vo.phone = this.loginUser.personMobile
            this.vo.preordainType = '0'
            this.vo.remark = ' '
            this.vo.site = this.cityName
            this.vo.week = this.meetingRoom.openday
            this.vo.weekProperties = this.meetingRoom.openday
            this.vo.weeks = this.meetingRoomopenday
            this.vo.status = 1

            console.log('this.vo', this.vo)
            this.$http({
                method: 'POST',
                url: 'hygl/meeting/insert',
                data: this.vo
            }).then((res) => {
                console.log(res)
                if (res.code == 'success') {
                    this.meetSubjedt = ''
                    this.attendeeser = []
                    this.showDialog = false
                    this.$bus.emit('getMeetData')
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                    this.status = 1
                }
            })
        }
    }
}
</script>
<style lang="scss">
.meetDialog {
    .el-dialog__header {
        background: transparent !important;
        border: 0;
        border-bottom: 1px solid;
        border-image: linear-gradient(270deg, rgba(217, 217, 217, 0) 0%, #d9d9d9 50.02%, rgba(217, 217, 217, 0) 100.91%) 2 2 2 2;
    }
    .el-dialog__footer {
        border: 0;
    }
}
</style>
<style scoped lang="scss">
.flex {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
}
.flex1 {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 15px;
}
.typeface {
    font-style: normal;
    font-weight: 400;
    font-size: var(--portalFontSize12);
}
.typeface1 {
    font-style: normal;
    font-weight: 400;
    font-size: var(--portalFontSize12);
    margin-top: 10px;
}
.allTime {
    width: 76px;
    background: #fafafa;
    border: 1px solid #ebebeb;
    border-radius: 8px;
}
.el-select {
    margin: 0 10px;
}
.el-button {
    background: linear-gradient(84.51deg, rgba(255, 106, 0, 0.8) 4.71%, rgba(255, 143, 36, 0.8) 98.9%);
    box-shadow: 0px 3.33333px 13.3333px rgba(255, 106, 0, 0.25);
    border-radius: 8px;
    width: 100%;
}
.button1 {
    width: 100%;
    height: 36px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    color: #fff;
}
.result {
    width: 100%;
    height: 100%;
    background: #ffffff;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    .user {
        width: 100%;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        border: 0;
        border-bottom: 1px solid;
        border-image: linear-gradient(270deg, rgba(217, 217, 217, 0) 0%, #d9d9d9 50.02%, rgba(217, 217, 217, 0) 100.91%) 2 2 2 2;
        .left {
            .name {
                font-size: var(--portalFontSize14);
                line-height: 20px;
                color: #000;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                white-space: nowrap;
            }
            .detial {
                width: 260px;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                white-space: nowrap;
                font-size: var(--portalFontSize12);
                line-height: 15px;
                color: rgba(0, 0, 0, 0.6);
            }
        }
    }
}
/deep/.el-input--suffix .el-input__inner {
    padding-right: 0px;
}
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 110px;
    background: #fafafa;
    border: 1px solid #ebebeb;
    border-radius: 8px;
    margin: 10px;
}
/deep/.el-input--medium .el-input__inner {
    background: #fafafa;
    border: 1px solid #ebebeb;
    border-radius: 8px;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    margin: 10px 7px;
}
/deep/.el-dialog .el-dialog__body {
    padding-bottom: 0px;
}
/deep/.el-input__suffix {
    right: 0px !important;
}
.scroll {
    overflow-y: scroll;
}
.scroll::-webkit-scrollbar {
    width: 5px;
    background-color: none;
}

.scroll::-webkit-scrollbar-track {
    background-color: none;
}

.scroll::-webkit-scrollbar-thumb {
    background: #eeecec;
    border-radius: 4px;
}
</style>
